import { atom } from "recoil";

// 選択できる検査オプションリスト
export const optionState = atom({
  key: "optionState",
  default: null,
});